module.exports = __webpack_public_path__ + "static/media/videocam-off-32px.d5f91c05.svg";